import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { motion } from 'framer-motion';

export const CTASection = ({
  title = "Ready to Transform Your Technology?",
  description = "Let's discuss how Voitech Solutions can help your organization achieve its goals.",
  primaryButtonText = "Request Consultation",
  primaryButtonLink = "/contact",
  secondaryButtonText,
  secondaryButtonLink,
  variant = 'default', // 'default' | 'accent' | 'gradient'
}) => {
  const variants = {
    default: 'bg-primary',
    accent: 'bg-accent',
    gradient: 'bg-hero-pattern',
  };

  return (
    <section className={`${variants[variant]} py-16 md:py-24 relative overflow-hidden`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-circuit-pattern opacity-10" />
      
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-background/5 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-background/5 rounded-full translate-y-1/2 -translate-x-1/2" />

      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
            {title}
          </h2>
          <p className="text-lg text-primary-foreground/80 mb-8">
            {description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild variant="hero-accent" size="xl">
              <Link to={primaryButtonLink}>
                {primaryButtonText}
                <ArrowRight className="w-5 h-5 ml-2" />
              </Link>
            </Button>
            {secondaryButtonText && secondaryButtonLink && (
              <Button asChild variant="hero-outline" size="xl" className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                <Link to={secondaryButtonLink}>
                  {secondaryButtonText}
                </Link>
              </Button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
